import { toast } from "react-toastify";

import {
  ResetToPausedExperienceRequestPathParamType,
  ResetToPausedExperienceResponseBodyType,
} from "@intelligems/ig-types";
import { officialCategoryName } from "@intelligems/ig-utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import {
  experienceKeys,
  invalidateModuleExperienceListQueries,
} from "../queryKeys";
import { ApiRequest } from "../types/api";

const resetToPausedExperience = async (
  payload: ApiRequest<undefined, ResetToPausedExperienceRequestPathParamType>
): Promise<ResetToPausedExperienceResponseBodyType> => {
  const resp = await api.post<ResetToPausedExperienceResponseBodyType>(
    `/v2/experiences/${payload.pathParams.experienceId}/reset-to-paused`,
    null
  );
  return resp.data;
};

export const useResetToPausedExperience = (experienceId: string) => {
  const queryClient = useQueryClient();
  return useMutation<
    ResetToPausedExperienceResponseBodyType,
    Error,
    ApiRequest<any, ResetToPausedExperienceRequestPathParamType>
  >({
    mutationFn: async (data) => resetToPausedExperience(data),
    onSuccess: async (data) => {
      invalidateModuleExperienceListQueries(queryClient);

      void queryClient.invalidateQueries({
        queryKey: experienceKeys.experimentList,
      });
      await queryClient.invalidateQueries({
        queryKey: experienceKeys.one(experienceId),
      });
      toast.success(
        `${officialCategoryName(data.experience.category, true)} Reset to Paused`
      );
    },
  });
};
